import { useEffect, useState } from "react";
import { ProductCard } from "../../components/client/ProductCard";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { useRef } from "react";
import { moneyFormat } from "../../util/format";
import { Link } from "react-router-dom";

export const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchParams] = useSearchParams();
  const keyword = searchParams.get("s");
  const category = searchParams.get("c");
  const [range, setRange] = useState([0, 100000000]);
  const debounceTimeout = useRef(null);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [sortBy, setSortBy] = useState("DESC");
  const [viewMode, setViewMode] = useState("grid"); // grid or list
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    getBrandData();
  }, []);

  useEffect(() => {
    getData(range);
  }, [currentPage, keyword, category, selectedBrands, sortBy]);

  const getData = (range) => {
    axios
      .get("/product/public/shows", {
        params: {
          page: currentPage,
          limit: 12,
          keyword: keyword,
          categoryId: category,
          priceMin: range[0],
          priceMax: range[1],
          brandId: selectedBrands.join(","),
          sort: sortBy,
        },
      })
      .then((res) => {
        const productData = res.data.data?.products;
        const totals = res.data.data?.totalPages;
        setProducts(productData);
        setTotalPages(totals);
      })
      .catch((err) => console.log(err));
  };

  const getBrandData = () => {
    axios
      .get("/public/brand/shows")
      .then((res) => {
        const brandData = res.data.data?.brands;
        setBrands(brandData);
      })
      .catch((err) => console.log(err));
  };

  const handleRangeChange = (newRange) => {
    setRange(newRange);

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      getData(newRange);
    }, 500);
  };

  const handleCheck = (id) => {
    setSelectedBrands((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id],
    );
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row px-xl-5">
          <div className="col-12">
            <nav className="breadcrumb bg-light mb-30">
              <Link className="breadcrumb-item text-dark" to="/">
                Trang chủ
              </Link>
              <Link className="breadcrumb-item text-dark" to="#">
                Sản phẩm
              </Link>
              <span className="breadcrumb-item active">Danh sách sản phẩm</span>
            </nav>
          </div>
        </div>
      </div>

      {/* Custom styles for view modes */}
      <style>{`
        /* Basic row styles */
        .product-grid.row,
        .product-list.row {
          display: flex;
          flex-wrap: wrap;
          margin-right: 2px;
          margin-left: 2px;
        }

        /* Ensure product wrapper has consistent padding */
        .product-wrapper {
          padding: 0 15px;
          margin-bottom: 30px;
        }

        /* Remove Bootstrap column padding as we handle it with product-wrapper */
        .product-grid > [class*="col-"],
        .product-list > [class*="col-"] {
          padding-right: 0;
          padding-left: 0;
        }

        /* Ensure items fill their containers */
        .product-grid .product-item,
        .product-list .product-item {
          height: 100%;
        }

        /* Proper handling of spacing in list mode */
        @media (max-width: 768px) {
          .product-list .product-wrapper {
            padding: 0 15px;
          }
        }
      `}</style>

      <div className="container-fluid">
        <div className="row px-xl-5">
          {/* Sidebar Filters */}
          <div className="col-lg-3 col-md-4">
            <div className="sticky-top" style={{ top: "20px" }}>
              <div className="bg-light p-4 mb-4 rounded">
                <h5 className="section-title position-relative text-uppercase mb-3">
                  <span className="bg-secondary pr-3">Lọc theo giá</span>
                </h5>
                <div className="w-full max-w-md mx-auto mt-4">
                  <label className="d-flex justify-content-between mb-2">
                    <span>{moneyFormat(range[0])}</span>
                    <span>{moneyFormat(range[1])}</span>
                  </label>
                  <Slider
                    range
                    min={0}
                    max={50000000}
                    step={10000}
                    value={range}
                    onChange={handleRangeChange}
                    trackStyle={[{ backgroundColor: "#28a745", height: 6 }]}
                    handleStyle={[
                      { borderColor: "#28a745", height: 20, width: 20 },
                      { borderColor: "#28a745", height: 20, width: 20 },
                    ]}
                    railStyle={{ backgroundColor: "#ddd", height: 6 }}
                  />
                </div>
              </div>

              <div className="bg-light p-4 rounded">
                <h5 className="section-title position-relative text-uppercase mb-3">
                  <span className="bg-secondary pr-3">
                    Lọc theo thương hiệu
                  </span>
                </h5>
                <div className="brand-filter">
                  {brands.map((brand, idx) => (
                    <div key={`brand-${idx}`} className="mb-2">
                      <div className="custom-control custom-checkbox d-flex align-items-center justify-content-between">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id={`brand-${idx}`}
                          checked={selectedBrands.includes(brand.id)}
                          onChange={() => handleCheck(brand.id)}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor={`brand-${idx}`}
                        >
                          {brand.name}
                        </label>
                        <span className="badge border font-weight-normal">
                          {brand.productCount}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Product List */}
          <div className="col-lg-9 col-md-8">
            <div className="row pb-3">
              <div className="col-12 pb-1">
                <div className="d-flex align-items-center justify-content-between mb-4">
                  <div className="d-flex align-items-center">
                    <div className="btn-group mr-2">
                      <button
                        className={`btn btn-sm ${
                          viewMode === "grid" ? "btn-primary" : "btn-light"
                        }`}
                        onClick={() => setViewMode("grid")}
                      >
                        <i className="fa fa-th-large"></i>
                      </button>
                      <button
                        className={`btn btn-sm ${
                          viewMode === "list" ? "btn-primary" : "btn-light"
                        }`}
                        onClick={() => setViewMode("list")}
                      >
                        <i className="fa fa-bars"></i>
                      </button>
                    </div>
                    <div className="ml-2">
                      <select
                        className="form-control form-control-sm"
                        value={sortBy}
                        onChange={(e) => setSortBy(e.target.value)}
                      >
                        <option value="ASC">Cũ nhất</option>
                        <option value="DESC">Mới nhất</option>
                        <option value="PRICE_DESC">Giá giảm dần</option>
                        <option value="PRICE_ASC">Giá tăng dần</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              {products?.length > 0 ? (
                <>
                  {products?.map((item, idx) => (
                    <div
                      key={`san-pham-${idx}`}
                      className={`${
                        viewMode === "grid"
                          ? "col-12 col-sm-6 col-md-6 col-lg-4"
                          : "col-12"
                      } mb-4 product-wrapper`}
                    >
                      <ProductCard product={item} viewMode={viewMode} />
                    </div>
                  ))}

                  <div className="col-12">
                    <nav
                      aria-label="Page navigation"
                      className="d-flex justify-content-center mt-4"
                    >
                      <ul className="pagination">
                        <li
                          className={`page-item ${
                            currentPage === 1 && "disabled"
                          }`}
                        >
                          <a
                            className="page-link"
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              if (currentPage > 1)
                                setCurrentPage(currentPage - 1);
                            }}
                          >
                            &laquo;
                          </a>
                        </li>
                        {Array.from(
                          { length: totalPages },
                          (_, i) => i + 1,
                        ).map((page) => (
                          <li
                            key={page}
                            className={`page-item ${
                              currentPage === page ? "active" : ""
                            }`}
                          >
                            <a
                              className="page-link"
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                setCurrentPage(page);
                              }}
                            >
                              {page}
                            </a>
                          </li>
                        ))}
                        <li
                          className={`page-item ${
                            currentPage === totalPages && "disabled"
                          }`}
                        >
                          <a
                            className="page-link"
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              if (currentPage < totalPages)
                                setCurrentPage(currentPage + 1);
                            }}
                          >
                            &raquo;
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </>
              ) : (
                <div className="col-12">
                  <div className="text-center py-5">
                    <i className="fa fa-search fa-3x text-muted mb-3"></i>
                    <h4 className="text-muted">Không tìm thấy sản phẩm</h4>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
